import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from './shared/services/user.service';
import { firstValueFrom } from 'rxjs';
import { TrackingService } from './shared/services/tracking.service';
@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <notifier-container></notifier-container>
  `,
})
export class AppComponent {
  title = 'Plataforma OZ';
  tuneTransactionId: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private titleService: Title,
    private userService: UserService,
    private trackingService: TrackingService
  ) {
    this.createSvgFlags();
  }

  ngOnInit() {
    sessionStorage.removeItem('hide-toast');
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        var rt = this.getChild(this.activatedRoute);

        rt.data.subscribe((data) => {
          this.titleService.setTitle(data.title);
        });
      });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.tuneTransactionId = params['transaction_id'];
      const affiliateId = params['affiliate_id'];
      if (affiliateId) localStorage.setItem('affiliate_id', affiliateId);
      if (this.tuneTransactionId && affiliateId) {
        localStorage.setItem('transaction_id', this.tuneTransactionId);
        firstValueFrom(
          this.userService.updateTuneTransaction(this.tuneTransactionId)
        );
        firstValueFrom(this.userService.updateTuneAffiliate(affiliateId));
      }
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  createSvgFlags() {
    this.matIconRegistry.addSvgIcon(
      'usd',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/usd.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'eur',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/eur.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'gbp',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/gbp.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chf',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/chf.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'aud',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/aud.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cad',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/cad.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'nzd',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/nzd.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'jpy',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/jpy.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'zar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/zar.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'dkk',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/dkk.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'nok',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/nok.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'brl',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/brl.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'sek',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/sek.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mxn',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/flags/mxn.svg')
    );
  }
}
